<template>
  <div class="main">
    <div>
      <Panel
        module="PDV"
        title="Locação"
        :showFilter="false"
        :showSearch="false"
        :showButtons="false"
      >
        <div slot="content-main">
          <br />
          <SuccessPdvRent :rentId="rentId" :msgSuccess="msgSuccess" />
        </div>
      </Panel>
    </div>
  </div>
</template>
<script>
import Panel from "@nixweb/nixloc-ui/src/component/layout/Panel";
import SuccessPdvRent from "../../../components/modules/pdv/rent/SuccessPdvRent.vue";

import { mapMutations } from "vuex";

export default {
  name: "SuccessPdvRentView",
  components: {
    Panel,
    SuccessPdvRent,
  },
  data() {
    return {
      msgSuccess: "Locação processada com sucesso!",
      rentId: this.$route.params.rentId,
    };
  },
  mounted() {
    this.removeLoading(["panel"]);
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
  },
};
</script>

<style scoped>
.main {
  margin-left: 120px;
  margin-top: 100px;
  margin: auto;
}

.title {
  color: #252422;
  margin: 0;
  text-align: center;
  font-size: 18px;
}
</style>